import React from "react";
import { Modal } from "react-bootstrap";
import IMAGES from "../Images";

export function ThankYouBox ({onBoard}) {
    return(
      <Modal
      id="modal4"
      size="md"
      show={onBoard}
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Body id="modal4" style={{justifyContent: "center",
    alignItems: "center",
    display: "flex",
    flexDirection: "column",
    padding: "1.5rem"}}>
        {/* {messageError && ( */}
          <React.Fragment>
            <img src={IMAGES.check} alt="" />
            <p>Thank you for registering with us!</p>
              <p style={{ color:"green", textAlign:"center" }}>
              please verify your email address by clicking the link we've sent to
                    your inbox
              </p>
            <p style={{ textAlign: "center" }}>
            Hold on! We are redirecting you to login page
            </p>
            {/* <MinimalLoader /> */}
          </React.Fragment>
        {/* ) } */}
      </Modal.Body>
    </Modal>
    );
  }